"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
function useBulkAction(_a) {
    var rowsId = _a.rowsId, selectedRowsId = _a.selectedRowsId, setSelectedRowsId = _a.setSelectedRowsId, placeholder = _a.placeholder, disabled = _a.disabled, getLabel = _a.getLabel, options = _a.options, onSelectAction = _a.onSelectAction, actionElement = _a.actionElement;
    var handleSelectAll = function (all) {
        if (all) {
            setSelectedRowsId(__spreadArray([], rowsId, true));
        }
        if (!all) {
            setSelectedRowsId([]);
        }
    };
    var handleOnSelectRow = function (id) {
        if (selectedRowsId.includes(id)) {
            var newSelectedRows = selectedRowsId.filter(function (rowId) { return rowId !== id; });
            setSelectedRowsId(newSelectedRows);
            return;
        }
        setSelectedRowsId(__spreadArray(__spreadArray([], selectedRowsId, true), [id], false));
    };
    var checkedLength = selectedRowsId.length;
    var trueOrIndeterminate = checkedLength === rowsId.length ? true : "indeterminate";
    var checked = checkedLength === 0 ? false : trueOrIndeterminate;
    var bulkAction = {
        checked: checked,
        placeholder: placeholder,
        disabled: disabled,
        getLabel: getLabel,
        onSelectAll: handleSelectAll,
        options: options,
        onSelectAction: onSelectAction,
        actionElement: actionElement,
    };
    return { bulkAction: bulkAction, handleOnSelectRow: handleOnSelectRow };
}
exports.default = useBulkAction;
//# sourceMappingURL=useBulkAction.js.map